import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export const JOB_TYP = {
    GWR_DATA_IMPORT: 'JobGwrDataImport',
    ANGRENZENDE_GEBAEUDE_IMPORT: 'JobAngrenzendeGebaeudeImport',
    GROSSVERBRAUCHER_IMPORT: 'JobGrossverbraucherImport',
    EINGESPEISTE_ENERGIE_IMPORT: 'JobEingespeisteEnergieImport',
    PRODUKTIONSEINHEITEN_IMPORT: 'JobProduktionseinheitenImport',
    SOLARSTROMANLAGEN_IMPORT: 'JobSolarstromanlagenImport',
    AUSWERTUNG_GEBAEUDE: 'JobAuswertungGebaeude',
    AUSWERTUNG_PRODUKTION: 'JobAuswertungProduktion',
}

export const STATUS = {
    QUEUED: 'queued',
    NEW: 'new',
    RUNNING: 'running',
    SUCCESS: 'success',
    FAILED: 'failed',
    CANCELED: 'canceled',
}

export class Job extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    typ: string | null = null;
    status: string | null = null;
    job_daten: object | null = null;
    progress: number | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'Job';
    }
}


export class JobCollection extends BaseCollection<Job> {
    protected modelCls = Job;

    public getModelClassName(): string {
        return 'Job';
    }
}
